import { render, staticRenderFns } from "./CmsSpace.vue?vue&type=template&id=3a186ce8"
import script from "./CmsSpace.vue?vue&type=script&lang=js"
export * from "./CmsSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports